import React, { useState } from 'react';
import { useReveal } from '../lib/useReveal';
const FAQS = [{
  q: '¿Sirve si nunca estudié Reiki antes?',
  a: 'Sí. El Tomo 1 — El Despertar del Canal — está diseñado para empezar desde cero. No necesitás experiencia previa.'
}, {
  q: '¿Cómo recibo el material?',
  a: '100% digital. En menos de 5 minutos después de tu compra recibís acceso completo a todos los tomos y bonos en PDF.'
}, {
  q: '¿El certificado es oficial?',
  a: 'Sí. El certificado de Academia Holística Argentina es internacional y está diseñado para enmarcarlo y mostrarlo en tu espacio de trabajo.'
}, {
  q: '¿Puedo usarlo para enseñar a otros?',
  a: 'Sí. Con el MegaPack tenés todo el sistema para practicar, certificarte y formar tus propios alumnos.'
}, {
  q: '¿Tiene garantía real?',
  a: '7 días sin preguntas. Si no es lo que esperabas te devolvemos el 100%. Sin formularios. Sin drama.'
}];
export function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#faf5fc] py-12 md:py-16 px-5 sm:px-6 border-t border-[#e8d5f0]" data-id="element-157">
      <div className="container mx-auto max-w-3xl" data-id="element-158">
        <div ref={ref1} className={`reveal text-center mb-10 ${vis1 ? 'is-visible' : ''}`} data-id="element-159">
          <h2 className="text-3xl md:text-5xl font-bold text-[#3d2a5f] mb-4" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-160">
            ❓ LO QUE MÁS NOS PREGUNTAN
          </h2>
        </div>

        <div className="space-y-3" data-id="element-161">
          {FAQS.map((faq, idx) => <div key={idx} className="bg-white rounded-xl border border-[#e8d5f0] overflow-hidden transition-all duration-300 shadow-sm" data-id="element-162">
              <button onClick={() => setOpenIdx(openIdx === idx ? null : idx)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" data-id="element-163">
                <span className="font-bold text-[#3d2a5f] pr-4" data-id="element-164">{faq.q}</span>
                <span className={`text-[#c9a14d] text-xl transition-transform duration-300 ${openIdx === idx ? 'rotate-45' : ''}`} data-id="element-165">
                  +
                </span>
              </button>
              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIdx === idx ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-166">
                <p className="text-[#6b5a85] text-sm leading-relaxed" data-id="element-167">
                  {faq.a}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}